module.exports = __webpack_public_path__ + "static/media/manat-white.b5963fe3.svg";